import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Stories from 'react-insta-stories';
import { isEmptyOrNil } from 'core/helpers';
import { FormattedTag } from 'core/components';
import { ModalWindow } from 'components/modal-window/modal-window';
import { withModalActions } from 'core/hocs';
import { MODAL_IDS } from '../../../constants';
import { getLocalStorageData, setLocalStorageData } from '../../../helpers/local-storage';

import './stories-modal.scss';

export class StoriesModalUI extends Component {
  static propTypes = {
    currentModal: PropTypes.shape({
      id: PropTypes.string,
      data: PropTypes.any
    }).isRequired,
    closeModal: PropTypes.func.isRequired,
  };

  seeMoreCollapsedComponent = (buttonName, buttonLink) => (
    <a
      href={buttonLink}
      className="d-flex align-items-center btn btn-primary mx-3 mb-3"
    >
      <FormattedTag
        id={buttonName}
        className="font-weight-semi-bold mx-auto mt-0_75 letter-spacing-default"
      />
    </a>
  );

  markStoryAsViewed = (id) => {
    const watchedStories = getLocalStorageData('watchedStories');

    if (isEmptyOrNil(watchedStories)) {
      setLocalStorageData('watchedStories', `${id.toString()},`);
    } else if (!watchedStories?.split(',').includes(id.toString())) {
      setLocalStorageData('watchedStories', `${watchedStories}${id},`);
    }
  }

  render() {
    const { currentModal, closeModal } = this.props;

    let storiesList = null;

    if (currentModal?.data?.items && Array.isArray(currentModal?.data?.items)) {
      storiesList = currentModal?.data?.items?.map(i => ({
        url: i.mediaType === 'image' ? i.mediaUrl.replace('.webp', '@3x.webp') : i.mediaUrl,
        header: {
          heading: i.name,
          profileImage: i.iconImage,
        },
        type: i.mediaType,
        trackingId: i.id,
        seeMore: i.buttonName ? () => <></> : null,
        seeMoreCollapsed: () => i.buttonName && i.buttonLink
          ? this.seeMoreCollapsedComponent(i.buttonName, i.buttonLink) : null,
      }));
    }

    return (
      <ModalWindow
        id={MODAL_IDS.STORIES}
        coreProps={{ id: MODAL_IDS.STORIES }}
        bodyClassName="p-0"
        className="stories-modal"
        fade
      >
        <div className="modal-stories-form-container">
          {storiesList && storiesList.length > 0 && (
            <Stories
              stories={storiesList}
              defaultInterval={3000}
              width="100%"
              height="100%"
              currentIndex={currentModal?.data?.startIndex}
              storyStyles={{ width: '100%' }}
              // eslint-disable-next-line react/jsx-no-bind
              onStoryStart={i => this.markStoryAsViewed(storiesList[i].trackingId)}
              // eslint-disable-next-line react/jsx-no-bind
              onAllStoriesEnd={() => closeModal(MODAL_IDS.STORIES)}
            />
          )}

        </div>
      </ModalWindow>
    );
  }
}

export const StoriesModal = withModalActions(StoriesModalUI);
